import React from 'react';

import PropTypes from 'prop-types';

import { useFeatures } from '@atc/features';

import {
    DisclaimerText,
    LinkIcon,
    Text,
} from 'reaxl';
import { InfoIcon } from 'reaxl-molecules';

import Card from './Card';
import CardContentWithAnalytics from './CardContentWithAnalytics';

function SafetyRecallCard({
    safetyRecall,
    handleRecallDetailsClick,
    handleContentImpression,
    listingId,
    isInverse,
    ...rest
}) {
    const {
        safety_recall: [, {
            hide_kbb_branding: hideKbbBranding = false,
            link_label: brandedLinkLabel,
        }],
    } = useFeatures([
        'safety_recall',
    ]);

    const { description, header, img, link, text } = safetyRecall ?? {};
    let linkLabel = safetyRecall?.linkLabel;

    if (hideKbbBranding && (linkLabel?.toLowerCase().includes('kbb') || linkLabel?.toLowerCase().includes('kelley blue book'))) {
        linkLabel = brandedLinkLabel;
    }

    return (
        <Card
            id="recall"
            heading={(
                <React.Fragment key="safety-recall-heading">
                    {header}
                    <InfoIcon
                        className="margin-left-1"
                        infoText={(<DisclaimerText>{description}</DisclaimerText>)}
                        placement="top"
                        popoverId="safetyRecall-disclaimer"
                        {...(isInverse && { textColor: 'text-inverse' })}
                    />
                </React.Fragment>
            )}
            image={img}
            link={link}
            showTile
            linkLabel={linkLabel}
            isInverse={isInverse}
            {...rest}
        >
            <CardContentWithAnalytics
                cardType="safetyRecall"
                handleContentImpression={handleContentImpression}
                listingId={listingId}
            >
                <Text
                    componentClass="p"
                    className="margin-bottom-2"
                >
                    {text}
                </Text>
                {link && (
                    <LinkIcon
                        target="_blank"
                        rel="nofollow noopener"
                        href={link}
                        glyph="offsite"
                        onClick={handleRecallDetailsClick}
                        inverse={isInverse}
                    >
                        {linkLabel}
                    </LinkIcon>
                )}
            </CardContentWithAnalytics>
        </Card>
    );
}

SafetyRecallCard.propTypes = {
    isInverse: PropTypes.bool,
};

export default SafetyRecallCard;
